'use client';

import { createContext, useContext } from 'react';

import type { useAvailableDates } from '../hooks/use-available-dates';

// ─── Types ───────────────────────────────────────────────────────────────

export type CalendarBookingContextValue = ReturnType<
  typeof useAvailableDates
> & {
  /** Incremented after each booking — widgets watch this to reset their selection. */
  bookingVersion: number;
  /** Call after a successful booking to refresh data and notify all widgets. */
  onBooked: () => void;
  /** Re-fetch available dates (and calendarAuthorized) — call after Google Calendar connect. */
  refreshFeatures: () => void;
};

// ─── Context ─────────────────────────────────────────────────────────────

export const CalendarBookingContext =
  createContext<CalendarBookingContextValue | null>(null);

// ─── Hook ────────────────────────────────────────────────────────────────

export function useCalendarBookingContext(): CalendarBookingContextValue | null {
  return useContext(CalendarBookingContext);
}
